import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DesignerContextType } from '../../types/designer-context-type';
import { LayoutType } from '../../types/layout-type';
import { ActivatedRoute, Router } from '@angular/router';
import { SxfDesignerService } from '../../services/sxfdesigner-service';
import { SxfPageDesignerService } from '../../services/page-service';
import { JsonEditorComponent } from 'angular4-jsoneditor/jsoneditor/jsoneditor.component';
import { SxMainContainer } from '../main/main-container.component';
import { SxDesignerService } from '../../services/designer-service';
import { CompleteDesignerContext } from '../main/completeContext';

@Component({
  selector: 'sx-list-modal',
  templateUrl: './list-modal.component.html',
})
export class SxListModalComponent {
  // Designer Context
  @Input()
  designerContext: DesignerContextType;
  // Selected ViewStyle
  @Input()
  selected: string;
  // Application Context
  @Input()
  completeContext: CompleteDesignerContext;
  // PrincipalDesignerReference
  @Input()
  mainContainer: SxMainContainer;
  // JsonEditorReference
  @Input()
  jsonEditor: JsonEditorComponent;

  @Output()
  saveConfiguration: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  successfullSaving: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private activatedRoute: ActivatedRoute,
    private formularioDinamicoService: SxfDesignerService,
    private pageService: SxfPageDesignerService,
    private router: Router
  ) {}

  // this function must save the current path and go the subpath
  goToSubList() {
    const product = this.designerContext.product;
    this.saveConfiguration.emit();
    if (!product.layout) {
      product.layout = new LayoutType();
    }
    if (this.selected === 'defaultPanel') {
      product.layout.root = this.mainContainer.getDesignerInfo();
    } else {
      product.layout.root = JSON.parse(this.jsonEditor.getText());
    }
    const controlCtxt = this.designerContext.selectedDesigner.controlContext;

    const service: SxDesignerService = !this.designerContext.page
      ? this.formularioDinamicoService
      : this.pageService;

    service
      .save(product)
      .then((res) => this.successfullSaving.emit(res))
      .then((_) => {
        this.readyNavigate();
        if (this.completeContext.listPath !== undefined) {
          this.router.navigate(['../', controlCtxt.path], {
            relativeTo: this.activatedRoute,
          });
        } else {
          this.router.navigate(['.', controlCtxt.codAtributo], {
            relativeTo: this.activatedRoute,
          });
        }
      });
  }

  readyNavigate(): void {
    for (const key in this.designerContext.designers) {
      let designer = this.designerContext.designers[key];
      if (designer) {
        designer.destroy();
        designer = null;
      }
    }
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/modals/list-modal.component.ts